<div class="min-h-screen flex">

  <!-- Panel izquierdo: imagen de fondo + branding (fijo) -->
  <div class="hidden lg:flex lg:w-1/2 xl:w-3/5 sticky top-0 h-screen shrink-0 relative flex-col justify-between p-10 bg-cover bg-center bg-no-repeat"
    style="background-image: url('assets/images/bg/receipt-bg.jpg')">
    <div class="absolute inset-0 bg-slate-900/40"></div>

    <!-- Logo -->
    <div class="relative z-10">
      @if (detail()?.companyLogoUrl) {
        <img [src]="detail()!.companyLogoUrl" alt="Logo empresa" class="h-16 w-auto max-w-[220px] object-contain drop-shadow-sm" />
      } @else {
        <img src="assets/images/pento-icon.png" alt="Pento" class="h-8 w-auto" />
      }
    </div>

    <!-- Tagline inferior -->
    <div class="relative z-10">
      <p class="text-white text-2xl font-semibold leading-snug max-w-sm">
        Pagos seguros,<br />simples y rápidos.
      </p>
      <p class="text-white/60 text-sm mt-2">pento.mx</p>
    </div>
  </div>

  <!-- Panel derecho: scrollable -->
  <div class="w-full lg:w-1/2 xl:w-2/5 flex flex-col bg-slate-100 overflow-y-auto">

    <!-- Logo arriba del detalle — solo mobile -->
    <div class="lg:hidden flex items-center px-6 pt-6 pb-2">
      @if (detail()?.companyLogoUrl) {
        <img [src]="detail()!.companyLogoUrl" alt="Logo empresa" class="h-9 w-auto max-w-[140px] object-contain" />
      } @else {
        <img src="assets/images/pento-icon.png" alt="Pento" class="h-7 w-auto" />
      }
    </div>

    <div class="flex-1 flex flex-col justify-center px-5 py-10 sm:px-10 max-w-lg w-full mx-auto">

      <!-- Loading -->
      @if (loading()) {
      <div class="bg-white rounded-2xl shadow-xl border border-slate-200 p-10 text-center">
        <div class="inline-block animate-spin rounded-full h-9 w-9 border-2 border-slate-200 border-t-slate-600 mb-4">
        </div>
        <p class="text-slate-400 text-sm">Cargando factura...</p>
      </div>
      }

      <!-- Error -->
      @else if (error()) {
      <div class="bg-white rounded-2xl shadow-xl border border-slate-200 p-10 text-center">
        <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-red-50 mb-4">
          <svg class="w-7 h-7 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z">
            </path>
          </svg>
        </div>
        <p class="text-slate-700 font-medium">No se pudo cargar el detalle</p>
        <p class="text-slate-400 text-sm mt-1">Verifica que la URL sea correcta.</p>
      </div>
      }

      @else if (detail(); as d) {
      @let sale = d.sale;
      @let currency = sale?.currency ?? 'MXN';

      <div class="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">

        <!-- Encabezado -->
        <div class="bg-slate-800 px-6 py-5 flex items-center gap-4">
          <div class="flex items-center justify-center w-11 h-11 rounded-full bg-white/15 shrink-0">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
              </path>
            </svg>
          </div>
          <div>
            <p class="text-white font-bold text-base leading-tight">Detalle de factura</p>
            <p class="text-slate-300 text-xs mt-0.5">Resumen y desglose de cargos</p>
          </div>
        </div>

        <!-- Cuerpo -->
        <div class="px-6 py-5 space-y-4">

          <!-- Factura -->
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Factura</p>
            <div class="flex items-center justify-between gap-2">
              <p class="font-mono font-semibold text-slate-800 text-sm">
                @if (sale?.series) { <span class="text-slate-400">{{ sale.series }} </span> }
                {{ sale?.number ?? '—' }}
              </p>
              @if (sale?.status; as st) {
              <p-tag [severity]="st === 'PAID' ? 'success' : (st === 'ISSUED' ? 'info' : 'secondary')">
                <span class="text-xs">{{ st }}</span>
              </p-tag>
              }
            </div>
          </div>

          <!-- Cliente -->
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Cliente</p>
            <p class="text-slate-800 text-sm font-medium">{{ getCustomerName(sale) }}</p>
            @if (sale.customer?.taxId) {
            <p class="text-slate-400 text-xs font-mono mt-0.5">{{ sale.customer.taxId }}</p>
            }
          </div>

          <!-- Fecha de emisión -->
          @if (sale.issueDate) {
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Fecha de emisión</p>
            <p class="text-slate-800 text-sm">{{ formatDate(sale.issueDate) }}</p>
          </div>
          }

          <!-- Fecha de pago -->
          @if (sale.paidAt) {
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Fecha de pago</p>
            <p class="text-slate-800 text-sm">{{ formatDate(sale.paidAt) }}</p>
          </div>
          }

          <!-- Líneas -->
          @if (sale.lines && sale.lines.length > 0) {
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-2">Detalle</p>
            <div class="space-y-2">
              @for (line of sale.lines; track line.id ?? $index) {
              <div class="flex justify-between gap-2 text-sm">
                <span class="text-slate-600 flex-1 min-w-0">{{ line.quantity ?? 0 }} × {{ line.description ?? '—' }}</span>
                <span class="text-slate-800 shrink-0 font-mono">{{ formatAmount(line.totalAmount, currency) }}</span>
              </div>
              }
            </div>
          </div>
          }

          <!-- Total -->
          <div class="bg-slate-50 rounded-xl px-4 py-3 flex justify-between items-center">
            <span class="text-xs font-semibold text-slate-500 uppercase tracking-widest">Total</span>
            <span class="text-2xl font-extrabold font-mono text-slate-900">{{ formatAmount(sale?.total, currency) }}</span>
          </div>

          <!-- Desglose de cargos -->
          @if (d.charges && d.charges.length > 0) {
          <div class="pt-2">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-3">Desglose de cargos</p>
            <div class="space-y-3">
              @for (charge of currentCharges(); track charge.id) {
              <div class="rounded-xl border border-slate-200 bg-slate-50 p-4">
                <div class="flex justify-between items-center gap-2 flex-wrap">
                  <span class="text-slate-700 text-sm font-semibold">
                    Pago {{ charge.paymentNumber ?? '—' }} de {{ charge.numberOfPayments ?? '—' }}
                  </span>
                  <p-tag [severity]="getChargeStatusSeverity(charge.status)">
                    <span class="text-xs">{{ getChargeStatusLabel(charge.status) }}</span>
                  </p-tag>
                </div>
                <div class="flex justify-between text-sm text-slate-500 mt-1.5">
                  <span>Vence: {{ formatDate(charge.dueDate) }}</span>
                  <span class="font-mono font-semibold text-slate-700">{{ formatAmount(charge.total, currency) }}</span>
                </div>
                @if (isChargePending(charge) && charge.paymentLink?.link) {
                <a [href]="getPaymentLinkUrl(charge)" target="_blank" rel="noopener noreferrer"
                  class="mt-3 flex items-center justify-center gap-2 w-full py-2.5 px-3 rounded-xl bg-slate-800 hover:bg-slate-700 text-white text-sm font-bold transition-colors shadow-sm">
                  <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z">
                    </path>
                  </svg>
                  Pagar ahora
                </a>
                }
              </div>
              }

            </div>
          </div>
          }

        </div>
      </div>

      <!-- Nueva tarjeta para pagos programados -->
      @if (scheduledCharges().length > 0) {
      <div class="mt-4 bg-white rounded-2xl shadow-lg border border-slate-200 overflow-hidden">
        <button (click)="showScheduledPayments.set(!showScheduledPayments())"
          class="w-full flex items-center justify-between px-6 py-4 bg-slate-50 hover:bg-slate-100 transition-colors focus:outline-none group">
          <div class="flex items-center gap-3">
            <div class="flex items-center justify-center w-8 h-8 rounded-full bg-slate-200 text-slate-500 group-hover:bg-slate-300 transition-colors">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
            </div>
            <span class="text-sm font-semibold text-slate-700">Ver pagos futuros ({{ scheduledCharges().length }})</span>
          </div>
          <svg class="w-5 h-5 text-slate-400 transition-transform duration-200" [class.rotate-180]="showScheduledPayments()"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </button>

        @if (showScheduledPayments()) {
        <div class="px-6 py-4 space-y-3 border-t border-slate-200 bg-white">
          @for (charge of scheduledCharges(); track charge.id) {
          <div class="rounded-xl border border-slate-100 bg-slate-50 p-4">
            <div class="flex justify-between items-center gap-2 flex-wrap">
              <span class="text-slate-700 text-sm font-semibold">
                Pago {{ charge.paymentNumber ?? '—' }} de {{ charge.numberOfPayments ?? '—' }}
              </span>
              <p-tag [severity]="getChargeStatusSeverity(charge.status)">
                <span class="text-xs">{{ getChargeStatusLabel(charge.status) }}</span>
              </p-tag>
            </div>
            <div class="flex justify-between text-sm text-slate-500 mt-1.5">
              <span>Vence: {{ formatDate(charge.dueDate) }}</span>
              <span class="font-mono font-semibold text-slate-700">{{ formatAmount(charge.total, currency) }}</span>
            </div>
          </div>
          }
        </div>
        }
      </div>
      }
      }

    </div>

    <!-- Footer -->
    <div class="px-6 py-4 text-center">
      <p class="text-slate-400 text-xs">© 2025 Pento &mdash; Pagos seguros</p>
    </div>
  </div>

</div>
